//
// Exclude hidden elements from Parsley
// --------------------------------------------------
if (typeof Parsley !== 'undefined' && typeof Parsley.options !== 'undefined') {
	Parsley.options.excluded = 'input[type=button], input[type=submit], input[type=reset], input[type=hidden], [disabled], :hidden';
}
